var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.titleDesc!=='')?_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.tableList,"columns":_vm.tableColumns}}):_c('p',{staticClass:"text-center p-t-10 text-16 text-gray"},[_vm._v("暂无数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }